import { Image } from 'expo-image';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { Text, createMqStyles, tokens } from '@fhs/ui';

interface Props {
  products: {
    id: string;
    name: string;
    image: string;
  }[];
  style?: StyleProp<ViewStyle>;
}

export function StepProducts({ products, style }: Props) {
  const styles = useMqStyles();
  const is1Product = products.length === 1;

  if (products.length === 0) {
    return null;
  }

  return (
    <View style={[styles.container, style]}>
      {products.map((product, index) => (
        <React.Fragment key={product.id}>
          <View style={[styles.item, is1Product && styles.horizontalItem]}>
            <Image
              contentFit="contain"
              source={{
                uri: product.image,
              }}
              style={[styles.image, is1Product && styles.horizontalImage]}
            />
            <Text.Ui size="sm" style={{ textAlign: 'center' }}>
              {product.name}
            </Text.Ui>
          </View>
          {index < products.length - 1 && <View style={styles.separator} />}
        </React.Fragment>
      ))}
    </View>
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      width: '100%',
      borderColor: tokens.colors.$blackOpacity10,
      borderWidth: 1,
      borderRadius: 8,
      flexDirection: 'row',
    },
  },
  item: {
    $base: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 12,
      flex: 1,
      gap: 4,
    },
  },
  image: {
    $base: {
      height: 56,
      width: '100%',
    },
  },
  horizontalItem: {
    $base: {
      flexDirection: 'row',
      gap: 12,
    },
  },
  horizontalImage: {
    $base: {
      width: 70,
    },
  },
  separator: {
    $base: {
      width: 1,
      backgroundColor: tokens.colors.$blackOpacity10,
      height: '100%',
    },
  },
});
